<template>
    <nav
        aria-label="Progress"
        data-spec-class="base_progressbar"
    >
        <!-- Desktop: Vertical Layout (lg and above) -->
        <ol
            role="list"
            class="hidden overflow-hidden pr-0 lg:block"
            data-spec-class="base_progressbar-desktop"
        >
            <slot />
        </ol>

        <!-- Mobile/Tablet: Horizontal Layout (below lg) -->
        <div
            class="lg:hidden"
            data-spec-class="base_progressbar-mobile"
        >
            <ol
                role="list"
                class="flex items-center justify-center space-x-2 sm:space-x-3"
            >
                <slot name="horizontal-steps" />
            </ol>
        </div>
    </nav>
</template>
